import React, { useState } from 'react';
import styled from 'styled-components';

// Interface for the label object
interface Label {
    key: string;
    value: string;
}

// Styled components for the button states
const ToggleButtonWrapper = styled.div`
  display: flex;
  width: 30%;
  justify-content: space-between;
  overflow: hidden;
  position: relative;
  z-index: 99;
  border-radius: 40px;
  padding: 4px;
  border: 1px solid #313233;
`;

// Styled component for the toggle button
interface ToggleButtonProps {
    isActive: boolean;
}

const ToggleButton = styled.button<ToggleButtonProps>`
  flex: 1;
  border: none;
  padding: 8px;
//   cursor: pointer;
  outline: none;
  font-size: 13px;
  font-weight: bold;
  background-color: ${({ isActive }) => isActive ? '#0AFC7F' : 'transparent'};
  color: ${({ isActive }) => isActive ? 'black' : 'white'};
  border: 2px solid ${({ isActive }) => isActive ? '#0AFC7F' : 'black'};
  transition: background-color 0.3s ease;
  border-radius: 20px;
  min-width: 35px;
`;

// Props interface for the TripleToggleButton component
interface TripleToggleButtonProps {
    labels: Label[];
    defaultLabelKey: string;
    onChange?: (label: Label) => void;
}

// React component for the triple toggle button
const TripleToggleButton: React.FC<TripleToggleButtonProps> = ({ labels, defaultLabelKey, onChange }) => {
    // Initialize activeIndex based on defaultLabel prop
    const defaultLabelIndex = labels.findIndex(label => label.key === defaultLabelKey);
    const [activeIndex, setActiveIndex] = useState<number>(defaultLabelIndex !== -1 ? defaultLabelIndex : 0);

    const handleToggle = (index: number) => {
        setActiveIndex(index);
        onChange && onChange(labels[index]);
    };

    return (
        <ToggleButtonWrapper>
            {labels.map((label, index) => (
                <ToggleButton
                    key={index}
                    isActive={activeIndex === index}
                    onClick={() => handleToggle(index)}
                >
                    {label.value}
                </ToggleButton>
            ))}
        </ToggleButtonWrapper>
    );
};

export default TripleToggleButton;
